import { dateUtils } from "components/helpers"
import { ColumnModel } from "components/library"

const dateStartTemplateBody = (rowData): string =>
  dateUtils.formatDateToLocale(rowData.fromDate)

const percentageColumnTemplateBody = (rowData): string =>
  `${rowData.ratePercentage}%`

const StandardPercentOfTurnoverColumns: ColumnModel[] = [
  {
    field: "id",
    header: "ID",
    sortable: true,
  },
  {
    field: "fromDate",
    header: "Effective From",
    sortable: true,
    body: dateStartTemplateBody,
  },
  {
    field: "transactionCurrencyDescription",
    header: "Currency",
    sortable: true,
  },
  {
    field: "statusDescription",
    header: "Status",
    sortable: true,
  },
  {
    field: "ratePercentage",
    header: "Current Rate",
    sortable: true,
    body: percentageColumnTemplateBody,
  },
]

export default StandardPercentOfTurnoverColumns
